<div class="library-container d-flex w-100 h-100 text-light overflow-hidden">

  <!-- Left Inner Sidebar (Playlists/Platforms) -->
  <aside class="inner-sidebar flex-shrink-0 d-flex flex-column p-3" [class.sidebar-open]="sidebarOpen()">
    <!-- Header inside sidebar -->
    <div class="sidebar-header d-flex justify-content-between align-items-center mb-4">
      <div class="profile-info d-flex align-items-center gap-2">
        <!--<div class="profile-avatar d-flex align-items-center justify-content-center">
          <i class="bi bi-person-fill text-white fs-5"></i>
        </div>-->
        <h3 class="fw-semibold text-truncate mb-0 fs-5">Your Games</h3>
      </div>
      <button class="btn btn-close btn-close-white d-lg-none" (click)="sidebarOpen.set(false)"
        aria-label="Close"></button>
    </div>

    <!-- Category: GAMES -->
    <div class="category-section mb-4">
      <div class="category-header text-uppercase text-secondary fw-bold mb-2">Games</div>
      <ul class="nav flex-column gap-1">
        @for (item of platformsList; track item.name) {
        <li class="nav-item">
          <button class="nav-link w-100 d-flex align-items-center justify-content-between py-1.5 px-2 rounded"
            [class.active]="selectedPlatform() === item.name" (click)="selectPlatform(item.name)">
            <div class="d-flex align-items-center gap-2">
              <i class="bi" [class]="item.icon"></i>
              <span class="item-name">{{ item.name }}</span>
            </div>
            @if (item.count !== null) {
            <span class="badge rounded-pill bg-black border border-secondary-sub text-muted small-badge">
              {{ item.count }}
            </span>
            }
          </button>
        </li>
        }
      </ul>
    </div>

    <!-- Category: STORE -->
    <!--<div class="category-section">
      <div class="category-header text-uppercase text-secondary fw-bold mb-2">Store</div>
      <ul class="nav flex-column gap-1">
        @for (item of storeList; track item.name) {
        <li class="nav-item">
          <button class="nav-link w-100 d-flex align-items-center justify-content-between py-1.5 px-2 rounded">
            <div class="d-flex align-items-center gap-2">
              <i class="bi" [class]="item.icon"></i>
              <span class="item-name">{{ item.name }}</span>
            </div>
          </button>
        </li>
        }
      </ul>
    </div>-->
  </aside>

  <!-- Main Library Grid View -->
  <div class="main-content flex-grow-1 d-flex flex-column overflow-hidden">

    <!-- Top Filter & Search Toolbar -->
    <header
      class="toolbar p-3 d-flex flex-wrap align-items-center justify-content-between gap-3 border-bottom border-secondary-sub">
      <!-- Navigation controls & View Title -->
      <div class="d-flex align-items-center gap-2 gap-sm-3">
        <button class="btn btn-dark-toolbar d-lg-none" (click)="sidebarOpen.set(!sidebarOpen())"
          title="Toggle Categories">
          <i class="bi bi-list fs-5"></i>
        </button>
        <div class="nav-arrows d-none d-sm-flex gap-1">
          <button class="btn btn-dark-toolbar btn-sm" title="Back" [disabled]="!canGoBack()" (click)="goBack()">
            <i class="bi bi-chevron-left"></i>
          </button>
          <button class="btn btn-dark-toolbar btn-sm" title="Forward" [disabled]="!canGoForward()"
            (click)="goForward()">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
        <h2 class="view-title mb-0 text-uppercase fw-bold text-white fs-5">{{ selectedPlatform() }}</h2>
        <span
          class="badge bg-secondary-sub rounded-pill px-3 py-1.5 text-uppercase text-light small-badge">Windows</span>
      </div>

      <!-- Action filters -->
      <div class="d-flex align-items-center gap-2 flex-wrap">

        <!-- Filter dropdown -->
        <div class="dropdown">
          <button class="btn btn-dark-toolbar d-flex align-items-center gap-2" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <i class="bi bi-funnel-fill"></i>
            <span>Filter</span>
            @if (selectedGenre() !== 'All') {
            <span class="badge bg-primary text-white">{{ selectedGenre() }}</span>
            }
          </button>
          <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end border-0 shadow">
            <li><button class="dropdown-item" (click)="selectedGenre.set('All')">All Genres</button></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('Shooter')">Shooters</button></li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('RPG')">RPG</button></li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('Action RPG')">Action RPG</button></li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('Strategy')">Strategy</button></li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('Simulation')">Simulation</button></li>
            <li><button class="dropdown-item" (click)="selectedGenre.set('Platformer')">Platformers</button></li>
          </ul>
        </div>

        <button class="btn btn-dark-toolbar" title="Add a Game"><i class="bi bi-plus-lg"></i></button>

        <!-- Search Bar -->
        <div class="search-input-wrapper position-relative">
          <i
            class="bi bi-search search-icon position-absolute start-0 top-50 translate-middle-y ms-2 text-secondary"></i>
          <input type="text" class="form-control form-control-sm search-bar bg-dark border-0 p-2 ps-5 text-white"
            placeholder="Search games..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
        </div>

        <!-- Sorting dropdown -->
        <div class="dropdown">
          <button class="btn btn-dark-toolbar" type="button" data-bs-toggle="dropdown" aria-expanded="false"
            title="Sort Order">
            <i class="bi bi-sliders"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end border-0 shadow">
            <li><button class="dropdown-item" (click)="sortBy.set('title-asc')">Sort: Name (A-Z)</button></li>
            <li><button class="dropdown-item" (click)="sortBy.set('title-desc')">Sort: Name (Z-A)</button></li>
            <li><button class="dropdown-item" (click)="sortBy.set('year-desc')">Sort: Release Year (Newest)</button>
            </li>
            <li><button class="dropdown-item" (click)="sortBy.set('size-desc')">Sort: Storage Size</button></li>
          </ul>
        </div>
      </div>
    </header>

    <!-- Grid Container -->
    <div class="grid-scroll-area flex-grow-1 p-4 overflow-auto">
      <div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4">
        @for (game of filteredGames(); track game.id) {
        <div class="col">
          <div class="card game-card border-0 bg-transparent shadow" [class.not-installed-card]="!game.installed"
            (click)="openGameDetails(game)">

            <!-- Card Image wrapper -->
            <div class="card-image-wrapper position-relative overflow-hidden rounded shadow">
              <img [src]="game.coverUrl" class="card-img-top game-cover" [class.grayscale-cover]="!game.installed"
                [alt]="game.title" loading="lazy">

              <!-- Install/Play state badge at top right -->
              @if (game.installed) {
              <span class="badge bg-purple-glow position-absolute top-0 end-0 m-2 border-0" title="Installed">
                <i class="bi bi-check-circle-fill"></i>
              </span>
              } @else {
              <span class="badge bg-dark-glow position-absolute top-0 end-0 m-2 border-0" title="Not Installed">
                <i class="bi bi-cloud-arrow-down-fill text-secondary"></i>
              </span>
              }

              <!-- Premium hover overlay with custom buttons -->
              <div class="card-overlay d-flex flex-column justify-content-between p-3">
                <!-- Top of overlay -->
                <div class="d-flex justify-content-between align-items-center w-100">
                  <span class="badge bg-dark-overlay small-badge border border-secondary text-light">
                    {{ game.platforms[0] }}
                  </span>
                </div>
                <!-- Middle of overlay: Big Launch Play Button -->
                <div class="d-flex justify-content-center align-items-center flex-grow-1">
                  @if (game.installed) {
                  <button
                    class="btn btn-play-glow rounded-circle d-flex align-items-center justify-content-center shadow-lg z-1"
                    (click)="playLaunchGame(game, $event)" title="Play Now">
                    <i class="bi bi-play-fill fs-4 ms-0.5"></i>
                  </button>
                  } @else {
                  <button
                    class="btn btn-download-glow rounded-circle d-flex align-items-center justify-content-center shadow-lg"
                    (click)="browseGamePath(game, $event)" title="Set Game Path">
                    <i class="bi bi-folder2-open fs-5"></i>
                  </button>
                  }
                </div>
                <!-- Bottom of overlay: Game Details details button -->
                <div class="text-center">
                  <span class="text-uppercase tracking-wider super-small fw-bold btn-details-text">
                    View Details
                  </span>
                </div>
              </div>
            </div>

            <!-- Card Body: Game Title & Details -->
            <div class="card-body p-2 px-2">
              <h6 class="card-title text-truncate fw-semibold text-light mb-0" [title]="game.title">
                {{ game.title }}
              </h6>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <span class="text-muted super-small text-truncate w-75">{{ game.developer }}</span>
                <span class="text-muted super-small">{{ game.releaseYear }}</span>
              </div>
            </div>
          </div>
        </div>
        }
        @if (filteredGames().length === 0) {
        <div class="col-12 text-center py-5">
          <i class="bi bi-controller fs-1 text-secondary mb-3 d-block"></i>
          <h5 class="text-muted">No games found matching your filters.</h5>
          <button class="btn btn-outline-secondary btn-sm mt-2"
            (click)="selectedPlatform.set('All games'); searchQuery.set(''); selectedGenre.set('All')">
            Reset Filters
          </button>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Standalone Game Details Modal Component -->
  <app-game-details-modal [game]="selectedGame()" (closed)="closeGameDetails()" (gameUpdated)="onGameUpdated($event)"
    (launched)="onGameLaunched($event)">
  </app-game-details-modal>

  <!-- Mobile Sidebar Backdrop Overlay -->
  @if (sidebarOpen()) {
  <div class="sidebar-backdrop d-lg-none" (click)="sidebarOpen.set(false)"></div>
  }

</div>